<template minapp='mpx' xlang='wxml'>
  <view
    class="es-container custom-class"
    wx:style="{{ {flexDirection: direction} }}"
    bindtap="containerTap"
  >
    <slot name="bg-icon"></slot>
    <view class="es-header" wx:if="{{slot.header}}">
      <es-navbar
        class="es-header__navbar"
        custom-class="custom-navbar"
        custom-title="custom-title"
        wx:if="{{title}}"
        wx:style="{{navbarStyle}}"
        on-click-left="{{navbarClickLeft}}"
        left-arrow="{{leftArrow}}"
        use-web-back="{{navbarUseWebBack}}"
      >
        {{ title }}
        <view slot="right" wx:if="{{useRight}}">
          <slot name="right" />
        </view>
      </es-navbar>
      <slot name="header"></slot>
    </view>
        <view class="es-main custom-main" wx:style="{{esMainStyle}}" bindscroll="handleScroll">
      <blank-page
        wx:if="{{useBlankPage}}"
        type="{{blankPageType}}"
        loadingContext="{{loadingContext}}"
        blankButtonContext="{{blankButtonContext}}"
        blankContextTitle="{{blankContextTitle}}"
        blankContextSubTitle="{{blankContextSubTitle}}"
        loadingImageUrl="{{loadingImageUrl}}"
        blankImageUrl="{{blankImageUrl}}"
        hasButton="{{hasBlankButton}}"
        hasSubTitle="{{hasBlankSubTitle}}"
        hasTitle="{{hasBlankTitle}}"
        setBlankContext="{{setBlankContext}}"
        blank-title-style="{{blankTitleStyle}}"
        blank-subtitle-style="{{blankSubtitleStyle}}"
        categoryLoadingTitle="{{categoryLoadingTitle}}"
        categoryLoadingDesc="{{categoryLoadingDesc}}"
        bind:click-button="clickButton"
      >
        <view slot="blankContextTitle">
          <slot name="blankContext" />
        </view>
      </blank-page>
      <slot wx:else></slot>
    </view>
    <view class="es-footer" wx:if="{{slot.footer}}">
      <slot name="footer-tips"></slot>
      <slot name="footer"></slot>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    externalClasses: ['custom-main', 'custom-navbar', 'custom-title', 'custom-class'],
    props: {
      layout: {
        type: Array,
        value: ['header']
      },
      esMainStyle: Object,
      useRight: Boolean,

      direction: {
        type: String,
        value: 'column'
      },

      navbarStyle: null,
      navbarClickLeft: null,
      leftArrow: Boolean,
      navbarUseWebBack: {
        type: Boolean,
        value: false
      },
      title: String,

      setBlankContext: {
        type: Boolean,
        value: false
      },
      blankPageType: {
        type: String,
        value: 'show-page'
      },
      useBlankPage: {
        type: Boolean,
        value: false
      },
      loadingContext: {
        type: String,
        value: '数据加载中...'
      },
      blankButtonContext: {
        type: String,
        value: '重试'
      },
      blankContextTitle: {
        type: String,
        value: '加载失败'
      },
      blankContextSubTitle: {
        type: String,
        value: '请检查网络设置或稍后重试'
      },
      loadingImageUrl: {
        type: String,
        value:
          'https://pt-starimg.didistatic.com/static/starimg/img/VY4SkVNwXT1644496067250.gif'
      },
      blankImageUrl: {
        type: String,
        value:
          'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
      },
      hasBlankButton: {
        type: Boolean,
        value: true
      },
      hasBlankSubTitle: {
        type: Boolean,
        value: true
      },
      hasBlankTitle: {
        type: Boolean,
        value: true
      },
      blankTitleStyle: null,
      blankSubtitleStyle: null,
      // 品类加载标题
      categoryLoadingTitle: {
        type: String,
        value: ''
      },
      // 品类加载描述
      categoryLoadingDesc: {
        type: String,
        value: ''
      },
      // 是否需要监听scroll
      needScroll: {
        type: Boolean,
        value: false
      }
    },

    computed: {
      slot() {
        return this.layout.reduce((slot, key) => ((slot[key] = true), slot), {})
      }
    },
    methods: {
      clickButton() {
        this.$trigger('blank-retry')
      },
      containerTap() {
        this.$trigger('container-tap')
      },
      handleScroll(e) {
        if(!this.needScroll) return 
        const detail = __mpx_mode__ === 'web'? e.target : e.detail
        const scrollTop = detail?.scrollTop || 0
        this.$trigger('onscroll',scrollTop)
      }
    }
  })
</script>

<style lang='stylus'>
  @import '../common/style/bem'

  +b('container')
    display flex
    height 100%
    flex 1
    flex-basis auto
    box-sizing border-box
    min-width 0
  +b('header')
    display flex
    flex-direction column
  +b('main')
    flex 1
    overflow-y auto
    background #eee
  +b('footer')
    display flex
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-navbar': '../navbar/index',
      'blank-page': '@/es-mpx-ui/lib/blank-page/index'
    }
  }
</script>

